import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import Logo from '../common/Logo';

/**
 * Two-column shell for the signup and login pages: form on the left, brand
 * panel on the right. The panel is hidden below lg — on a phone the form is the
 * only thing that matters.
 */
export default function AuthLayout({ children, aside }) {
  return (
    <div className="mm-auth">
      <div className="mm-auth__form-col">
        <div className="mm-auth__nav">
          <Link to="/" aria-label="MindlyFriend home">
            <Logo />
          </Link>

          <Link to="/" className="mm-auth__back">
            <FiArrowLeft size={15} aria-hidden="true" />
            Back to site
          </Link>
        </div>

        <div className="mm-auth__card-wrap">
          <div className="mm-auth__card">{children}</div>
        </div>
      </div>

      <aside className="mm-auth__aside">
        <span className="mm-auth__aside-blob mm-auth__aside-blob--1" aria-hidden="true" />
        <span className="mm-auth__aside-blob mm-auth__aside-blob--2" aria-hidden="true" />
        <div className="mm-auth__aside-inner">{aside}</div>
      </aside>
    </div>
  );
}
